<div style="padding-left: 16px; font-size: 12px;">
    <p class="password-requirement">
        <mat-icon *ngIf="!hasMinLength()" color="warn" class="password-requirement-icon">info</mat-icon>
        <mat-icon *ngIf="hasMinLength()" class="password-requirement-icon password-requirement-met">check_circle</mat-icon>
        New Password requires at least <strong>8</strong> characters.
    </p>
    <p class="password-requirement">
        <mat-icon *ngIf="!hasUpperCharacter()" color="warn" class="password-requirement-icon">info</mat-icon>
        <mat-icon *ngIf="hasUpperCharacter()" class="password-requirement-icon password-requirement-met">check_circle</mat-icon>
        New Password requires one upper character.
    </p>
    <p class="password-requirement">
        <mat-icon *ngIf="!hasLowerCharacter()" color="warn" class="password-requirement-icon">info</mat-icon>
        <mat-icon *ngIf="hasLowerCharacter()" class="password-requirement-icon password-requirement-met">check_circle</mat-icon>
        New Password requires one lower character.
    </p>
    <p class="password-requirement">
        <mat-icon *ngIf="!hasNumber()" color="warn" class="password-requirement-icon">info</mat-icon>
        <mat-icon *ngIf="hasNumber()" class="password-requirement-icon password-requirement-met">check_circle</mat-icon>
        New Password requires one number.
    </p>
    <p class="password-requirement">
        <mat-icon *ngIf="!hasSpecialCharacter()" color="warn" class="password-requirement-icon">info</mat-icon>
        <mat-icon *ngIf="hasSpecialCharacter()" class="password-requirement-icon password-requirement-met">check_circle</mat-icon>
        New Password requires one special character.
    </p>
    <p class="password-requirement">
        <mat-icon *ngIf="!hasMatchingPasswords()" color="warn" class="password-requirement-icon">info</mat-icon>
        <mat-icon *ngIf="hasMatchingPasswords()" class="password-requirement-icon password-requirement-met">check_circle</mat-icon>
        The Confirm Password entry must match the New Password entry.
    </p>
</div>